import { DependencyList, useMemo } from 'react'
import { AnnotationsMap, makeAutoObservable } from 'mobx'

export const useObservable = <T extends object | null>(
    initializer: () => T,
    deps: DependencyList = [],
    overrides?: AnnotationsMap<NonNullable<T>, never>
): T => {
    return useMemo(() => {
        const state = initializer()
        if (!state) {
            return state
        }
        return makeAutoObservable(state, overrides, { autoBind: true })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps)
}
